import { createSlice } from "@reduxjs/toolkit";
import { fetchReleasedTracks } from "../thunks/trackThunks";

const initialState = {
	releasedTracks: [],
	loading: false,
	error: null,
};

const releasesSlice = createSlice({
	name: "tracks",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchReleasedTracks.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(fetchReleasedTracks.fulfilled, (state, action) => {
				state.loading = false;
				state.tracks = action.payload.tracks;
				state.pagination = action.payload.pagination;
			})
			.addCase(fetchReleasedTracks.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			});
	},
});

export default releasesSlice.reducer;
